// ============================================================
// Mock data for Rehabilitated For Life (Rehab4Life180) clone
// All data here is MOCKED for the frontend-only preview.
// Will be replaced with real backend APIs later.
// ============================================================

export const company = {
  name: "Rehabilitated For Life SSM",
  shortName: "RFL",
  tagline: "Financial Wellbeing Coaches",
  phone: "(980) 294-7187",
  email: "info@rehab4life180.com",
  supportEmail: "support@rehab4life180.com",
  website: "www.rehab4life180.com",
  division: "A Division of Covenant Group Holdings, LLC",
  copyright: "Copyright © 2018 Rehabilitated For Life SSM. All rights reserved.",
};

export const announcements = [
  "Are You Looking For A Business Opportunity?  Ask Us How You Can Increase Your Income!",
  "As an affiliate or referral partner, You Can Make Money Easily!",
  "Did You Know That You Have Rights To Restoring Your Credit?",
  "Are You In Foreclosure?  We Can Help!",
];

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about-us" },
  { label: "Credit Resources", href: "#credit-resources" },
  { label: "Services", href: "#services" },
  { label: "Books", href: "/books" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Terms & Conditions", href: "/terms" },
];

export const hero = {
  kicker: "Financial Coaches",
  title: "What We Do",
  subtitle:
    "As Financial Wellbeing Coaches, we guide individuals, families and small businesses to discover faith based, practical solutions for their financial challenges! We accomplish helping others by listening to and understanding their situation, providing valuable education and financial tools, and providing encouragement to reach their goals.",
  image:
    "https://images.unsplash.com/photo-1628705249474-fdf782614c21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxmYW1pbHklMjBmcmVlZG9tfGVufDB8fHx8MTc4MjA3MzE1NXww&ixlib=rb-4.1.0&q=85",
  ctaPrimary: "Book a Free Consultation",
  ctaSecondary: "Explore Services",
};

export const about = {
  heading: "About Us",
  lead:
    "Our experienced professionals have helped many people just like you with similar issues and concerns. We specialize in creating an approach that is designed to address your individual situation. We are a self-supporting ministry, and your financial contributions are considered as donations.",
  image:
    "https://images.unsplash.com/photo-1672380135241-c024f7fbfa13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMGhhbmRzaGFrZXxlbnwwfHx8fDE3ODIwNzMxNTV8MA&ixlib=rb-4.1.0&q=85",
  addressList: [
    "Investing principles and strategies",
    "Retirement investing and distribution strategies",
    "Estate conservation issues",
    "Risk management",
  ],
  questions: [
    "Can I retire early?",
    "Are my investments working hard enough?",
    "What's a suitable approach for college savings?",
    "What are the elements of a sound estate strategy?",
    "Do I have enough life insurance for my family?",
  ],
};

export const creditResources = [
  {
    id: "identity-iq",
    title: "Identity IQ",
    description: "Protect your good name with Identity IQ Credit Monitoring.",
    cta: "Get Protected Today!",
    link: "https://www.identityiq.com/sc-securepreferred.aspx?offercode=431253H1",
    image:
      "https://images.unsplash.com/photo-1651126433991-11dda0eb78ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "business-capital",
    title: "Business Capital",
    description: "Your Growth Catalyst: Funding for Every Entrepreneur.",
    cta: "Get Capital Now!",
    link: "#",
    image:
      "https://images.pexels.com/photos/5912592/pexels-photo-5912592.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "first-progress",
    title: "First Progress Platinum Mastercard Secured",
    description: "Get Approved FAST!",
    cta: "Get Approved!",
    link: "#",
    image:
      "https://images.unsplash.com/photo-1589758438368-0ad531db3366?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "first-latitude",
    title: "First Latitude Platinum",
    description:
      "Credit Line Secured by Your Fully-Refundable Deposit of $200 – $2,000 Submitted with Application.",
    cta: "Increase Your Scores Today!",
    link: "#",
    image:
      "https://images.unsplash.com/photo-1563013544-824ae1b704d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "rfl-agreement",
    title: "RFL Working Agreement",
    description: "Agreement is structured to protect you and RFL!",
    cta: "Sign Now!",
    link: "#",
    image:
      "https://images.pexels.com/photos/7876501/pexels-photo-7876501.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "credit-score-iq",
    title: "Credit Score IQ",
    description:
      "The smart software to help you build credit. Personalized tools you need to get the credit scores you deserve! More than 1 in 3 people have inaccuracies on their credit report.",
    cta: "Get Started!",
    link: "#",
    image:
      "https://images.unsplash.com/photo-1633158829875-e5316a358c6f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

// icon names map to lucide-react icons in the component
export const services = [
  {
    id: 1,
    icon: "ShieldCheck",
    title: "Life Insurance Solutions",
    description:
      "We offer standard and industry leading Life Insurance products no matter what your current health condition is.",
  },
  {
    id: 2,
    icon: "PiggyBank",
    title: "Retirement Planning",
    description:
      "Secure your retirement with a custom created plan. We help you build a risk free financial roadmap so you enjoy the golden years stress-free.",
  },
  {
    id: 3,
    icon: "TrendingUp",
    title: "Wealth Management",
    description:
      "Our team manages your existing portfolio and recommends cutting edge strategies to grow your money risk free and in many cases TAX-FREE.",
  },
  {
    id: 4,
    icon: "Building2",
    title: "Small Business Solutions",
    description:
      "Tired of your bank and the IRS taking your hard earned money? Our business clients grow their cash value and work toward financial freedom.",
  },
  {
    id: 5,
    icon: "CreditCard",
    title: "Credit and Debt Management",
    description:
      "Know the difference between how much you owe (debt) and how much you can borrow (credit). Learn how to manage both to avoid financial trouble.",
  },
  {
    id: 6,
    icon: "Receipt",
    title: "Tax Planning",
    description:
      "Guidance on tax-efficient strategies to minimize tax liabilities, review of tax returns, and advice on deductions, credits and more.",
  },
  {
    id: 7,
    icon: "GraduationCap",
    title: "Education Funding",
    description:
      "Plan for education expenses such as saving for college. We provide info on college savings plans, scholarships and financial aid options.",
  },
  {
    id: 8,
    icon: "Briefcase",
    title: "Business Financial Consulting",
    description:
      "We assist businesses in managing finances, analyzing cash flow, evaluating profitability, and making strategic financial decisions.",
  },
  {
    id: 9,
    icon: "Brain",
    title: "Behavioral Finance Coaching",
    description:
      "Understand your financial behavior, biases and emotions. We coach you to make informed decisions and develop healthy financial habits.",
  },
  {
    id: 10,
    icon: "ClipboardList",
    title: "Financial Planning",
    description:
      "Develop comprehensive financial plans based on your goals, risk tolerance and time horizon — budgets, savings targets and investment strategies.",
  },
];

export const legacyPillars = [
  {
    number: "01",
    title: "Build",
    text: "Establish a strong financial foundation with proven, faith-based principles tailored to your life.",
  },
  {
    number: "02",
    title: "Grow",
    text: "Expand your wealth and opportunities with cutting-edge, risk-managed strategies.",
  },
  {
    number: "03",
    title: "Protect",
    text: "Safeguard your family and legacy with insurance, estate planning and lasting protection.",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Patrica T.",
    location: "Ocala, FL",
    quote:
      "I have known my financial well-being coach for the past seven years and find him to be a very knowledgeable and competent individual. Prior to knowing him, I had no long term financial plan and was deeply in debt. After being introduced to him, my financial life has stabilized and improved tremendously over time.",
  },
  {
    id: 2,
    name: "Eugene L.",
    location: "Greensboro, NC",
    quote:
      "I came to know of my financial well-being coach through a friend in church. He is quite approachable and open in sharing information about the products and market, making it easier for me to balance my long-term financial needs with my immediate needs. I would be happy to recommend his services.",
  },
  {
    id: 3,
    name: "Willis G.",
    location: "Denver, CO",
    quote:
      "Professionally, he is competent, knowledgeable and has a holistic approach to financial planning. He listens well and recommends products accordingly. Since knowing him, I have seen growth in my investments and have greater peace of mind.",
  },
  {
    id: 4,
    name: "Myles C.",
    location: "Alexandria, VA",
    quote:
      "His style has been refreshing in that he engenders a simple and straightforward approach that is both reassuring and intimate. In a world full of advice, I have found my truly trusted financial well-being coach.",
  },
];

export const successStats = [
  { value: "96%", label: "Clients change their financial situation in weeks" },
  { value: "7+", label: "Years of trusted relationships" },
  { value: "5★", label: "Level client support, guaranteed" },
  { value: "10", label: "Comprehensive coaching services" },
];

export const footer = {
  mission:
    "To help individuals, families and small business owners take control of their finances through providing faith based, practical solutions using an educational approach.",
  partners:
    "RFL maintains a list of highly qualified trusted partners that you may find helpful. We are happy to refer clients to them as needed.",
};

export const termsContent = {
  sms: {
    title: "SMS Terms and Conditions",
    paragraphs: [
      "By opting in to receive SMS messages from Rehab4Life180, you agree to receive recurring automated promotional and informational text messages from or on behalf of Rehab4Life180 at the mobile number you provided. These messages may include appointment reminders, wellness updates, service information, and exclusive offers.",
      "Consent is not a condition of any purchase. Message and data rates may apply. Message frequency may vary. You represent that you are the account holder or have the account holder's permission to enroll in this SMS program.",
    ],
    optOut:
      "You may opt out at any time by replying STOP to any message. After opting out, you will receive a confirmation that you have been unsubscribed. For assistance, reply HELP or contact us directly.",
    privacy:
      "We respect your privacy. Your phone number and personal information will only be used for communicating with you about Rehab 4 Life 180 services and will not be sold or shared with third parties.",
  },
  privacy: {
    title: "Privacy Policy",
    intro:
      "At Rehab4Life180, your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, interact with us through SMS or email, or use our services.",
    collect: [
      "Name",
      "Email address",
      "Phone number",
      "Appointment details",
      "Health-related intake forms (as applicable)",
      "IP address and device/browser data",
    ],
    use: [
      "Schedule and confirm appointments",
      "Communicate via SMS or email",
      "Improve our services and website",
      "Provide wellness-related updates or offers",
      "Comply with legal and regulatory requirements",
    ],
    rights: [
      "Request access to your data",
      "Request corrections or deletion",
      "Opt out of SMS or marketing communications at any time",
    ],
  },
  disclaimer:
    "This website contains educational information about general and credit matters. The information is not advice, and should not be treated as such. You must not rely on the information on this website as an alternative to legal advice from your attorney or other professional legal services provider.",
};

// ============================================================
// CRM mock data (seed). Persisted to localStorage at runtime.
// ============================================================

export const crmAdmin = {
  email: "admin@rehab4life180.com",
  password: "admin123",
  name: "Phil Dickens",
  role: "Administrator",
};

export const seedLeads = [
  {
    id: "l1",
    name: "Marcus Johnson",
    email: "marcus.j@gmail.com",
    phone: "919-555-0142",
    service: "Credit and Debt Management",
    message: "Looking to repair my credit score before buying a home.",
    status: "New",
    source: "Website",
    createdAt: "2025-07-08T14:32:00Z",
  },
  {
    id: "l2",
    name: "Tanya Williams",
    email: "tanya.w@yahoo.com",
    phone: "704-555-0188",
    service: "Retirement Planning",
    message: "Want to discuss early retirement options.",
    status: "Contacted",
    source: "Referral",
    createdAt: "2025-07-06T09:15:00Z",
  },
  {
    id: "l3",
    name: "Derrick Smalls",
    email: "dsmalls@outlook.com",
    phone: "336-555-0177",
    service: "Business Capital",
    message: "Need funding for my landscaping business expansion.",
    status: "Qualified",
    source: "Website",
    createdAt: "2025-07-03T16:45:00Z",
  },
  {
    id: "l4",
    name: "Angela Brooks",
    email: "angela.brooks@gmail.com",
    phone: "252-555-0199",
    service: "Life Insurance Solutions",
    message: "Family of four, looking for affordable life insurance.",
    status: "New",
    source: "Social Media",
    createdAt: "2025-07-09T11:05:00Z",
  },
];

export const seedClients = [
  {
    id: "c1",
    name: "Patrica Thompson",
    email: "patrica.t@gmail.com",
    phone: "352-555-0123",
    location: "Ocala, FL",
    stage: "Active",
    services: ["Wealth Management", "Retirement Planning"],
    value: 4800,
    joinedAt: "2024-02-12",
    notes: [
      { id: "n1", text: "Completed initial portfolio review. Very satisfied.", date: "2025-06-20" },
      { id: "n2", text: "Scheduled quarterly check-in for August.", date: "2025-07-01" },
    ],
  },
  {
    id: "c2",
    name: "Eugene Lewis",
    email: "eugene.l@gmail.com",
    phone: "336-555-0145",
    location: "Greensboro, NC",
    stage: "Active",
    services: ["Financial Planning"],
    value: 2200,
    joinedAt: "2024-08-03",
    notes: [
      { id: "n3", text: "Single income family. Building emergency fund plan.", date: "2025-06-28" },
    ],
  },
  {
    id: "c3",
    name: "Willis Green",
    email: "willis.g@gmail.com",
    phone: "303-555-0166",
    location: "Denver, CO",
    stage: "Closed",
    services: ["Wealth Management"],
    value: 7500,
    joinedAt: "2023-11-19",
    notes: [
      { id: "n4", text: "Investment growth on track. Renewed engagement.", date: "2025-05-15" },
    ],
  },
];

export const seedAppointments = [
  {
    id: "a1",
    clientName: "Marcus Johnson",
    type: "Free Consultation",
    date: "2025-07-15",
    time: "10:00 AM",
    status: "Confirmed",
    notes: "First-time credit consultation.",
  },
  {
    id: "a2",
    clientName: "Patrica Thompson",
    type: "Quarterly Review",
    date: "2025-07-18",
    time: "2:00 PM",
    status: "Confirmed",
    notes: "Portfolio performance review.",
  },
  {
    id: "a3",
    clientName: "Tanya Williams",
    type: "Retirement Strategy",
    date: "2025-07-22",
    time: "11:30 AM",
    status: "Pending",
    notes: "Discuss early retirement roadmap.",
  },
];

export const seedServiceCatalog = [
  { id: "s1", name: "Credit and Debt Management", category: "Credit", price: 299, active: true, clients: 18 },
  { id: "s2", name: "Retirement Planning", category: "Planning", price: 499, active: true, clients: 12 },
  { id: "s3", name: "Wealth Management", category: "Wealth", price: 899, active: true, clients: 9 },
  { id: "s4", name: "Life Insurance Solutions", category: "Insurance", price: 0, active: true, clients: 24 },
  { id: "s5", name: "Business Capital", category: "Funding", price: 0, active: true, clients: 7 },
  { id: "s6", name: "Tax Planning", category: "Planning", price: 350, active: false, clients: 4 },
];

export const leadStatuses = ["New", "Contacted", "Qualified", "Converted", "Lost"];
export const clientStages = ["Lead", "Onboarding", "Active", "Closed"];
export const appointmentStatuses = ["Pending", "Confirmed", "Completed", "Cancelled"];
